<template>
  <div>

    <b-card title="Comentarios">

      <app-timeline class="mb-3">
        <!-- 12 INVOICES HAVE BEEN PAID -->
        <app-timeline-item
          v-for="(comment, index) in planningOrder.comments"
          :key="index"
          variant="warning"
        >
          <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">

            <p>{{ comment.comment }}</p>
            <small class="text-muted">{{ formatDateVariant(comment.created_at) }}</small>
          </div>
          <h6 class="mb-0">
            {{ comment.user.full_name }}
          </h6>
          <p class="mb-0">
            {{ comment.user.role.name }}
          </p>
          <hr>
        </app-timeline-item>
      </app-timeline>

      <div class="text-right">
        <b-button
          v-if="userData.role_id == 5 && planningOrder.is_paid && planningOrder.planning_pdf"
          size="sm"
          variant="info"
          class="mt-2 mr-1"
          @click="commentModal = true; onlyCommentForm = false;"
        >
          Aprobar planificación
        </b-button>
        <b-button
          size="sm"
          variant="info"
          class="mt-2"
          @click="commentModal = true; onlyCommentForm = true;"
        >
          Agregar comentario
        </b-button>
      </div>

    </b-card>

    <!-- modal comment-->
    <b-modal
      v-model="commentModal"
      cancel-variant="outline-secondary"
      ok-title="Guardar"
      cancel-title="Cancelar"
      centered
      title="Ingresar comentario"
      @ok.prevent="savePlanningComment"
    >
      <validation-observer
        v-if="onlyCommentForm"
        ref="simpleRules"
      >
        <b-form>
          <b-form-group>
            <validation-provider
              #default="{ errors }"
              name="Comentario"
              rules="required"
            >
              <label for="comment">Comentario</label>
              <b-form-textarea
                id="comment"
                v-model="form.comment"

                placeholder="Ingresa un comentario"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-form>
      </validation-observer>

      <validation-observer
        v-else
        ref="simpleRules"
      >
        <b-form>
          <b-form-group
            v-slot="{ ariaDescribedby }"
            label="Aprobación de planificación (.pdf)"
          >
            <validation-provider
              #default="{ errors }"
              name="Aprobación de planificación (.pdf)"
              rules="required"
            >
              <b-form-radio
                v-model="form.approve"
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                value="si"
              >
                Aprobada
              </b-form-radio>
              <b-form-radio
                v-model="form.approve"
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                value="no"
              >
                No aprobada
              </b-form-radio>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <div v-if="form.approve === 'si'">

            <p>Selecciona la cantidad de alineadores a fabricar</p>

            <b-form-group

              label="Cant. alineadores superiores"
            >
              <validation-provider
                #default="{ errors }"
                name="Cant. alineadores superiores"
                rules="required"
              >
                <b-form-select
                  v-model="form.upper_aligners"
                  :state="errors.length > 0 ? false : null"
                  :options="upperAligners"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group

              label="Cant. alineadores inferiores"
            >
              <validation-provider
                #default="{ errors }"
                name="Cant. alineadores inferiores"
                rules="required"
              >
                <b-form-select
                  v-model="form.lower_aligners"
                  :state="errors.length > 0 ? false : null"
                  :options="lowerAligners"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

          </div>

          <b-form-group>
            <validation-provider
              #default="{ errors }"
              name="Comentario"
              rules="required"
            >
              <label for="comment">Comentario</label>
              <b-form-textarea
                id="comment"
                v-model="form.comment"
                placeholder="Ingresa un comentario"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-form>
      </validation-observer>

    </b-modal>

  </div>
</template>

<script>
import {
  BCard,
  BImg,
  BMedia,
  BAvatar,
  BButton,
  BCardHeader,
  BForm,
  BModal,
  BFormInput,
  BFormGroup,
  BFormTextarea,
  BAlert,
  BCardText,
  BFormRadio,
  BFormSelect,
} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import api from '@/plugin/axios'
import { required } from '@core/utils/validations/validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { includes } from 'core-js/internals/array-includes'
import { formatDate } from '@/helpers/utils'

export default {
  components: {
    BFormSelect,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormInput,
    BModal,
    BForm,
    BButton,
    BCard,
    BImg,
    BMedia,
    BAvatar,
    BFormTextarea,
    BAlert,
    BCardText,
    BFormRadio,
    AppTimeline,
    AppTimelineItem,
  },
  props: {
    planningOrder: {
      type: Object,
      required: true,
    },
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      commentModal: false,
      commentManagement: false,
      onlyCommentForm: false,
      required,
      form: {
        planning_order_id: '',
        comment: '',
        approve: null,
        upper_aligners: null,
        lower_aligners: null,
      },
      upperAligners: [],
      lowerAligners: [],
    }
  },
  computed: {
    formatDateVariant() {
      return date => formatDate(date)
    },
  },
  created() {
    this.upperAligners = this.createArray(this.planningOrder.number_upper_aligners)
    this.lowerAligners = this.createArray(this.planningOrder.number_lower_aligners)

    console.log(this.upperAligners, this.lowerAligners)
  },
  methods: {
    includes,
    savePlanningComment() {
      this.loading = true
      this.onlyComment()
    },
    createArray(n) {
      return Array.from({ length: n + 1 }, (_, i) => i)
    },
    onlyComment() {
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
          try {
            this.form.planning_order_id = this.planningOrder.id
            const response = await api.put('/api/planning-orders/comments', this.form)
            this.$bvToast.toast('Comentario enviado y registrado con éxito', {
              title: '¡Satisfactoriamente!', // Título del toast
              variant: 'success', // Color del toast
              solid: true, // Hace que el toast no sea translúcido
              autoHideDelay: 5000, // Duración en milisegundos (opcional)
              appendToast: true, // Asegura que se muestre como el más reciente
            })

            if (this.userData.role_id === 5 && !this.onlyCommentForm) {
              this.$router.push({ name: 'admin-checkout-aligners', params: { id: response.data.fabrication.planning_order_id, fabrication: response.data.fabrication.id, payment_type: 'fabricacion' } })
            } else {
              this.$router.push({ name: 'admin-planning-orders' })
            }
          } catch (error) {
            if (error.response && error.response.data.errors) {
              const messages = Object.values(error.response.data.errors).flat().join('\n')

              this.$bvToast.toast(messages, {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            } else {
              this.$bvToast.toast('Ocurrió un error inesperado', {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            }
          } finally {
            this.loading = false
            this.commentModal = false
          }
        }
      })
    },
  },
}
</script>

<style>

</style>
